import React from 'react'
import { formatPremium } from '@utils/giCar/utils'
import styles from './challanCard.module.scss'

const TITLE_MAX_LENGTH = 60

export type ChallanListItem = {
    title: string
    location: string
    date: string
    amount: number
}

export type ChallanCardProps = ChallanListItem & {
    isExpanded?: boolean
    onToggleExpand?: () => void
}

const ChallanCard = ({ title, location, date, amount, isExpanded, onToggleExpand }: ChallanCardProps) => {
    const isOverflowing = (title?.length ?? 0) > TITLE_MAX_LENGTH
    const displayTitle = isOverflowing && !isExpanded ? `${title.slice(0, TITLE_MAX_LENGTH)}...` : title

    return (
        <div className={styles.challanCard}>
            <div className={styles.challanCardRow}>
                <div className={styles.challanCardInfo}>
                    <div className={styles.challanCardTitle}>
                        {displayTitle}
                        {isOverflowing && (
                            <>
                                {' '}
                                <button type="button" className={styles.seeMore} onClick={onToggleExpand}>
                                    {isExpanded ? 'see less' : 'see more'}
                                </button>
                            </>
                        )}
                    </div>
                    <div className={styles.challanCardMeta}>
                        <div className={styles.challanCardMetaRow}>
                            <img src="https://acko-cms.ackoassets.com/location_792b8900ce.svg" />
                            <div className={styles.challanCardMetaText}>{location}</div>
                        </div>
                        <div className={styles.challanCardMetaRow}>
                            <img src="https://acko-cms.ackoassets.com/calendar_1800f1f496.svg" />
                            <div className={styles.challanCardMetaText}>{date}</div>
                        </div>
                    </div>
                </div>
                <div className={styles.challanCardAmount}>{formatPremium(Math.floor(amount || 0))}</div>
            </div>
        </div>
    )
}

export default ChallanCard
